import React from 'react';
import { useSpeech } from '../hooks/useSpeech';
import { renderMarkdown } from '../utils/markdown';

export const Flashcard = ({ card, direction, isFlipped, onFlip, counter, isFavorited, onToggleFavorite }) => {
  const showArabic = direction === 'ar';
  const { isSupported, isSpeaking, speak } = useSpeech();

  const handleSpeak = (e, text, lang) => {
    e.stopPropagation(); // Prevent card flip
    speak(text, lang);
  };

  const handleFavorite = (e) => {
    e.stopPropagation(); // Prevent card flip
    if (onToggleFavorite) {
      onToggleFavorite();
    }
  };

  return (
    <div className={`flashcard ${isFlipped ? 'flipped' : ''}`} onClick={onFlip}>
      <div className="card-inner">
        {/* Front */}
        <div className="card-face card-front">
          <div className="card-header">
            <div className="card-header-left">
              <div className="card-label">{showArabic ? 'ARABIC' : 'ENGLISH'}</div>
              {card.dialect && <div className="dialect-badge">Dialect</div>}
            </div>
            <button
              className={`favorite-btn ${isFavorited ? 'favorited' : ''}`}
              onClick={handleFavorite}
              title={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
            >
              {isFavorited ? '⭐' : '☆'}
            </button>
            <div className="card-counter">{counter}</div>
          </div>
          <div className="card-content">
            {card.image && (
              <div className="flashcard-image-container">
                <img src={card.image} alt="Card visual" className="flashcard-image" />
              </div>
            )}
            <div
              className="card-text"
              dangerouslySetInnerHTML={renderMarkdown(showArabic ? card.ar : card.en)}
            />
            {isSupported && (
              <button
                className={`speak-btn ${isSpeaking ? 'speaking' : ''}`}
                onClick={(e) => handleSpeak(e, showArabic ? card.ar : card.en, showArabic ? 'ar-SA' : 'en-US')}
                title="Listen to pronunciation"
              >
                🔊
              </button>
            )}
            {card.tags && card.tags.length > 0 && (
              <div className="flashcard-tags">
                {card.tags.map((tag, i) => (
                  <span key={i} className="flashcard-tag">{tag}</span>
                ))}
              </div>
            )}
          </div>
          <div className="card-footer">
            <div className="card-hint">Tap to flip</div>
          </div>
        </div>

        {/* Back */}
        <div className="card-face card-back">
          <div className="card-header">
            <div className="card-header-left">
              <div className="card-label">{showArabic ? 'ENGLISH' : 'ARABIC'}</div>
              {card.dialect && <div className="dialect-badge">Dialect</div>}
            </div>
            <button
              className={`favorite-btn ${isFavorited ? 'favorited' : ''}`}
              onClick={handleFavorite}
              title={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
            >
              {isFavorited ? '⭐' : '☆'}
            </button>
            <div className="card-counter">{counter}</div>
          </div>
          <div className="card-content">
            {card.image && (
              <div className="flashcard-image-container">
                <img src={card.image} alt="Card visual" className="flashcard-image" />
              </div>
            )}
            <div
              className="card-text"
              dangerouslySetInnerHTML={renderMarkdown(showArabic ? card.en : card.ar)}
            />
            {isSupported && (
              <button
                className={`speak-btn ${isSpeaking ? 'speaking' : ''}`}
                onClick={(e) => handleSpeak(e, showArabic ? card.en : card.ar, showArabic ? 'en-US' : 'ar-SA')}
                title="Listen to pronunciation"
              >
                🔊
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
